import { DashboardModule } from '@domain-group/suit-theme'

import useTaskList from '@hooks/useTaskList'

import Overview from './Overview'

interface DetailsProps {
  taskListPayload: ReturnType<typeof useTaskList>,
}

const Details = (props: DetailsProps) => {
  const {
    taskListPayload: {
      callbacks: {
        createOrEditTaskList,
      },
      taskList,
      taskList: { title },
    },
  } = props

  return (
    <DashboardModule contentBoxProps={{ flexDirection: 'column' }} title={title || 'Loading...'}>
      <Overview callbacks={{ createOrEditTaskList }} taskList={taskList} />
    </DashboardModule>
  )
}

export default Details
